import { useBreakpoints } from '@vueuse/core';
import { computed } from 'vue';

const breakpointsConfig = {
  xxs: 320,
  xs: 480,
  sm: 768,
  im: 992,
  md: 1280,
  il: 1440, // intermediate-large
  lg: 1680,
};

const customBreakpoints = useBreakpoints(breakpointsConfig);

export default function useCustomBreakpoints() {
  const isSmallMobile = computed(() => customBreakpoints.smallerOrEqual('xs').value);
  const isMobile = computed(() => customBreakpoints.smallerOrEqual('sm').value);
  const isTablet = computed(() => customBreakpoints.between('sm', 'im').value);
  const isDesktop = computed(() => customBreakpoints.greaterOrEqual('md').value);
  const isWideDesktop = computed(() => customBreakpoints.greaterOrEqual('lg').value);

  return {
    ...customBreakpoints,
    isSmallMobile,
    isMobile,
    isTablet,
    isDesktop,
    isWideDesktop,
  };
}
